<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" color="#FEBD08">
      <v-layout wrap>
        <v-flex xs11>
          {{ msg }}
        </v-flex>
        <v-flex xs1>
          <v-icon @click="snackbar = !snackbar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
     <AppHeader />
    <v-divider></v-divider>
    <v-layout pt-16 pt-md-0 wrap justify-center>
      
      <v-flex xs12 md10 pt-md-15 pt-lg-5>
        <v-card flat min-height="100vh">
          <!-- <v-layout pt-16 pt-md-0 wrap justify-center justify-md-start>
        <span style="font-family: poppinssemibold; font-size: 28px">
          Privacy Policy</span
        >
      </v-layout> -->
          <v-layout pt-4 px-4 px-md-0   wrap justify-center>
            <v-flex xs12 sm11 md12 text-left>
              <span v-html="policyData.content"></span>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import AppHeader from "./../../layout/AppHeader";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      heading: null,
      content: null,
      appLoading: false,
      snackbar: false,
      msg: null,
      ServerError: false,
      tab: null,
      policyData: {},
      items: [
        {
          title: "SELLER",
          type: "Seller",
        },
        {
          title: "CUSTOMER",
          type: "Customer",
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;

      axios({
        method: "get",
        url: "/privacyPolicy/view",
        headers: {
          token: localStorage.getItem("token"),
     
        },
             params: {
            type: "Customer",
            id: "6177c7c06e88076594ac280f",
          },
      })
        .then((response) => {
          this.appLoading = false;
          // var tempData = [];
          if (response.data.status) {
            this.policyData = response.data.data;
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>